// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .app {
    height: 100vh;
    overflow: scroll;
  }
  
  /* ---------- HEADER ---------- */
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 15px 20px;
    border-bottom: 1px solid #ddd;
  }
  
  .header h1 {
    font-size: 20px;
    color: #333;
  }
  
  .user {
    font-size: 14px;
    color: #777;
  }
  
  /* ---------- CARDS ---------- */
  .cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 15px;
    margin-top: 20px;
  }
  
  .card {
    background: white;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  }
  
  .card h2 {
    color: #ff7b00; /* orange as primary */
    margin: 0;
  }
  
  .card .title {
    margin: 5px 0;
  }
  
  .card .target {
    font-size: 13px;
    color: red;
  }
  
  .chart-placeholder {
    background: #ffe3c7;
    height: 120px;
    border-radius: 6px;
    margin-top: 10px;
  }
  
  /* ---------- TABLE ---------- */
  .table-container {
    margin-top: 20px;
    padding: 10px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    overflow-x: auto;
    width: 95%;
  }
  
  .table-container h3 {
    margin: 10px 0;
    color: #ff7b00;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }
  
  th, td {
    padding: 10px;
    text-align: center;
    border-bottom: 1px solid #eee;
  }
  
  th {
    background: #fff4e5;
    color: #ff7b00;
  }
  
  .positive-row {
    background: #f9fff6;
  }
  
  .negative-row {
    background: #fff5f5;
  }
  
  .trend-up {
    color: green;
    font-weight: bold;
  }
  
  .trend-down {
    color: red;
    font-weight: bold;
  }
  
  .view-btn {
    background: #ff7b00;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .view-btn:hover {
    background: #e66a00;
  }
  
  /* ---------- USER SELECT DROPDOWN ---------- */
.user-select {
    padding: 6px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    background-color: white;
    color: #333;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    transition: border 0.2s ease-in-out;
  }
  
  /* Focus / hover state */
  .user-select:hover,
  .user-select:focus {
    border-color: #ff7b00; /* orange border on hover/focus */
    box-shadow: 0 0 3px rgba(255, 123, 0, 0.5);
  }
  
  .tabs {
    display: flex;
    gap: 10px;
    margin-top: 15px;
  }
  
  .tab {
    padding: 8px 16px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s ease-in-out;
  }
  
  .tab:hover {
    border-color: #ff7b00;
  }
  
  .tab.active {
    background: #ff7b00;
    color: white;
    border-color: #ff7b00;
  }


  :root {
    --orange: #ff7a00;
    --card-bg: #fffaf5;
    --border: #ffe0c2;
    --text-dark: #222;
    --text-muted: #555;
  }
  
  .dashboard {
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: sans-serif;
  }
  
  .card-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
  
  .card {
    background: var(--card-bg);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }
  
  .card-title {
    font-size: 14px;
    color: var(--text-muted);
    margin-bottom: 12px;
  }
  
  .big-number {
    font-size: 32px;
    font-weight: bold;
    color: var(--text-dark);
    margin-bottom: 6px;
  }
  
  .highlight {
    color: var(--orange);
    font-weight: 600;
  }
  
  .row {
    display: flex;
    justify-content: space-between;
    margin: 6px 0;
  }
  
  .bold {
    font-weight: bold;
  }
  
  .metrics-container {
    background: var(--card-bg);
    border: 1px solid var(--border);
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }
  
  .metrics-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
  }
  
  .metrics-title {
    font-weight: 600;
    color: var(--text-dark);
  }
  
  .metrics-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .metrics-table th,
  .metrics-table td {
    padding: 8px;
    border-bottom: 1px solid #f2f2f2;
    text-align: center;
  }
  
  .metrics-table th:first-child,
  .metrics-table td:first-child {
    text-align: left;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/sales-dashboard/sales-dashboard.css"],"names":[],"mappings":";;EAEE;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,qCAAqC;EACvC;;EAEA;IACE,cAAc,EAAE,sBAAsB;IACtC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,+CAA+C;AACjD;IACI,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,mCAAmC;EACrC;;EAEA,wBAAwB;EACxB;;IAEE,qBAAqB,EAAE,iCAAiC;IACxD,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,qBAAqB;EACvB;;;EAGA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;IAEE,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB","sourcesContent":["\n  \n  .app {\n    height: 100vh;\n    overflow: scroll;\n  }\n  \n  /* ---------- HEADER ---------- */\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: white;\n    padding: 15px 20px;\n    border-bottom: 1px solid #ddd;\n  }\n  \n  .header h1 {\n    font-size: 20px;\n    color: #333;\n  }\n  \n  .user {\n    font-size: 14px;\n    color: #777;\n  }\n  \n  /* ---------- CARDS ---------- */\n  .cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 15px;\n    margin-top: 20px;\n  }\n  \n  .card {\n    background: white;\n    padding: 15px;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n  }\n  \n  .card h2 {\n    color: #ff7b00; /* orange as primary */\n    margin: 0;\n  }\n  \n  .card .title {\n    margin: 5px 0;\n  }\n  \n  .card .target {\n    font-size: 13px;\n    color: red;\n  }\n  \n  .chart-placeholder {\n    background: #ffe3c7;\n    height: 120px;\n    border-radius: 6px;\n    margin-top: 10px;\n  }\n  \n  /* ---------- TABLE ---------- */\n  .table-container {\n    margin-top: 20px;\n    padding: 10px;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0 2px 5px rgba(0,0,0,0.1);\n    overflow-x: auto;\n    width: 95%;\n  }\n  \n  .table-container h3 {\n    margin: 10px 0;\n    color: #ff7b00;\n  }\n  \n  table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n  }\n  \n  th, td {\n    padding: 10px;\n    text-align: center;\n    border-bottom: 1px solid #eee;\n  }\n  \n  th {\n    background: #fff4e5;\n    color: #ff7b00;\n  }\n  \n  .positive-row {\n    background: #f9fff6;\n  }\n  \n  .negative-row {\n    background: #fff5f5;\n  }\n  \n  .trend-up {\n    color: green;\n    font-weight: bold;\n  }\n  \n  .trend-down {\n    color: red;\n    font-weight: bold;\n  }\n  \n  .view-btn {\n    background: #ff7b00;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n  \n  .view-btn:hover {\n    background: #e66a00;\n  }\n  \n  /* ---------- USER SELECT DROPDOWN ---------- */\n.user-select {\n    padding: 6px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    background-color: white;\n    color: #333;\n    font-size: 14px;\n    cursor: pointer;\n    outline: none;\n    transition: border 0.2s ease-in-out;\n  }\n  \n  /* Focus / hover state */\n  .user-select:hover,\n  .user-select:focus {\n    border-color: #ff7b00; /* orange border on hover/focus */\n    box-shadow: 0 0 3px rgba(255, 123, 0, 0.5);\n  }\n  \n  .tabs {\n    display: flex;\n    gap: 10px;\n    margin-top: 15px;\n  }\n  \n  .tab {\n    padding: 8px 16px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s ease-in-out;\n  }\n  \n  .tab:hover {\n    border-color: #ff7b00;\n  }\n  \n  .tab.active {\n    background: #ff7b00;\n    color: white;\n    border-color: #ff7b00;\n  }\n\n\n  :root {\n    --orange: #ff7a00;\n    --card-bg: #fffaf5;\n    --border: #ffe0c2;\n    --text-dark: #222;\n    --text-muted: #555;\n  }\n  \n  .dashboard {\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    font-family: sans-serif;\n  }\n  \n  .card-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n  }\n  \n  .card {\n    background: var(--card-bg);\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    padding: 20px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  }\n  \n  .card-title {\n    font-size: 14px;\n    color: var(--text-muted);\n    margin-bottom: 12px;\n  }\n  \n  .big-number {\n    font-size: 32px;\n    font-weight: bold;\n    color: var(--text-dark);\n    margin-bottom: 6px;\n  }\n  \n  .highlight {\n    color: var(--orange);\n    font-weight: 600;\n  }\n  \n  .row {\n    display: flex;\n    justify-content: space-between;\n    margin: 6px 0;\n  }\n  \n  .bold {\n    font-weight: bold;\n  }\n  \n  .metrics-container {\n    background: var(--card-bg);\n    border: 1px solid var(--border);\n    border-radius: 16px;\n    padding: 20px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  }\n  \n  .metrics-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 12px;\n  }\n  \n  .metrics-title {\n    font-weight: 600;\n    color: var(--text-dark);\n  }\n  \n  .metrics-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .metrics-table th,\n  .metrics-table td {\n    padding: 8px;\n    border-bottom: 1px solid #f2f2f2;\n    text-align: center;\n  }\n  \n  .metrics-table th:first-child,\n  .metrics-table td:first-child {\n    text-align: left;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
